<template>
  <div>
    <md-whiteframe
      md-tag="md-toolbar"
      md-elevation="2"
      v-bind:class="{ 'md-large': large }"
    >
      <div class="md-toolbar-container">
        <md-button
          class="md-icon-button nav-trigger"
          v-on:click.native="toggleLeftSidenav"
        >
          <md-icon>menu</md-icon>
        </md-button>
        <h2 class="md-title main-title">{{ title }}</h2>
        <slot name="header-button"></slot>
      </div>
      <slot name="header"></slot>
    </md-whiteframe>
    <div class="main-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    large: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    toggleLeftSidenav() {
      this.$root.$emit("toggleLeftSidenav");
    }
  }
};
</script>

<style></style>
